import {isEmpty} from 'lodash'
import {getImageUrl, onError} from '@/libs/helper'

export default {
    name: 'DonationList',
    props: {
        donations: {
            type: Object,
            default: () => {}
        },
        isFetching: {
            type: Boolean,
            default: false
        }
    },
    
    data() {
        return {
            onError,
            getImageUrl
        }
    },
    methods: {
        /**
         * route to the dashboard of donation
         * @param {*} id 
         */
        routeToDonationPage (id, type) {
            if (!isEmpty(id)) this.$router.push({name: 'donations-profile', params: {id, type: type.toLowerCase()}})
        }
    },
}